import React, { CSSProperties, FC, HTMLAttributes } from 'react'

import cn from 'classnames'

import classes from './text.module.scss'

interface TitleProps extends HTMLAttributes<HTMLHeadingElement> {
  center?: boolean
  marginBottom?: string
  marginTop?: string
  weight?: string
}

export const Title: FC<TitleProps> = ({
  center,
  marginBottom,
  marginTop,
  weight,
  className,
  style,
  children,
  ...rest
}) => (
  <h1
    className={cn(classes.title, { [classes.center]: center }, className)}
    style={
      {
        ...style,
        '--title-margin-bottom': marginBottom,
        '--title-margin-top': marginTop,
        '--title-font-weight': weight,
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </h1>
)

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
  center?: boolean
  marginBottom?: string
  weight?: string
}

export const Heading: FC<HeadingProps> = ({
  center,
  marginBottom,
  weight,
  className,
  style,
  children,
  ...rest
}) => (
  <h2
    className={cn(classes.heading, { [classes.center]: center }, className)}
    style={
      {
        ...style,
        '--heading-margin-bottom': marginBottom,
        '--heading-font-weight': weight,
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </h2>
)

interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  weight?: string
  size?: string
  center?: boolean
  margin?: string
  lineHeight?: string
  color?: string
}

export const Paragraph: FC<ParagraphProps> = ({
  weight,
  size,
  center,
  margin,
  lineHeight,
  color,
  className,
  style,
  children,
  ...rest
}) => (
  <p
    className={cn(classes.paragraph, { [classes.center]: center }, className)}
    style={
      {
        ...style,
        '--p-font-weight': weight,
        '--p-font-size': size,
        '--p-margin': margin,
        '--p-line-height': lineHeight,
        '--p-color': color,
      } as CSSProperties
    }
    {...rest}
  >
    {children}
  </p>
)

interface HeadingTertiaryProps extends HTMLAttributes<HTMLHeadingElement> {
  green?: boolean
}

export const HeadingTertiary: FC<HeadingTertiaryProps> = ({
  green,
  className,
  children,
  ...rest
}) => (
  <h3
    className={cn(
      classes.headingTertiary,
      { [classes.green]: green },
      className
    )}
    {...rest}
  >
    {children}
  </h3>
)
